import $ from 'jquery';
import wx from 'weixin-js-sdk';
import wxUtils from 'utils/wxUtils';
import bankFn from './utils/special/bankFn';
import { getUrlParam } from './utils';
import VConsole from 'vconsole';

const isShowConsole = getUrlParam('showConsole') || '';
if (isShowConsole === '1') {
  new VConsole();
}

// 引入各行特殊的js
bankFn();

// 立即用 WeixinJSBridge 屏蔽菜单(兼容旧客户端,无需签名)
wxUtils.optionMenu(false);

const isWeChat = /MicroMessenger/i.test(navigator.userAgent);
// iOS 微信 SPA 路由切换后签名仍需用入口 URL;Android 用当前 URL
const entryUrl = window.location.href.split('#')[0];
let shareDisabled = false;
let signatureLoading = false;

function disableWeChatShare() {
  if (!isWeChat || shareDisabled || signatureLoading) return;

  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const url = isIOS ? entryUrl : window.location.href.split('#')[0];

  signatureLoading = true;
  $.ajax({
    type: 'post',
    url: 'https://weixin.dragonpass.com.cn/weixin/share',
    data: { url },
    dataType: 'json',
    success(result) {
      wx.config({
        debug: false,
        appId: result.appId,
        timestamp: result.timestamp,
        nonceStr: result.nonceStr,
        signature: result.signature,
        jsApiList: ['hideOptionMenu'],
      });
      wx.error((res) => console.log('wx config error:', res));
      wx.ready(() => {
        wx.hideOptionMenu();
        shareDisabled = true;
      });
    },
    error(err) {
      console.log('weixin share signature failed:', err);
    },
    complete() {
      signatureLoading = false;
    },
  });
}

export function onRouteChange({ location, routes, action }) {
  // Instana上报路由信息
  if (window.ineum && ['uat', 'prod'].includes(process.env.ENV)) {
    window.ineum('page', location.pathname);
  }
  // 禁止微信分享
  disableWeChatShare();
}
